import { useCallback, useEffect, useState } from 'react';
import Iframe from 'react-iframe';
import Loader from '../../../../components/Loader';
import PageHeader from '../../../../components/PageHeader';
import Sidebar from '../../../../components/Sidebar';
import Transitions from '../../../../components/Transition';
import { useAppContext } from '../../../../contexts/auth';
import useApiCall from '../../../../hooks/useApiCall';
import useLocalState from '../../../../hooks/useLocalState';
import LinesService from '../../../../services/affreightment/LinesService';
import { MapContainer } from './styles';

export default function LineMap() {
  const [isLoading, setIsLoading] = useState(true);
  const [lineMapBeingShow] = useLocalState('lineMapBeingShow');

  const { userData, token, signOut, selectedCompany } = useAppContext();
  const companyCode = selectedCompany.value;
  const { userCode, userName, userProfile } = userData;

  const { lineCode, lineSign, routeId } = lineMapBeingShow;

  const { apiCall } = useApiCall();

  const getMap = useCallback(async () => {
    await apiCall({
      apiToCall: LinesService.getMapShape,
      queryParams: {
        codUsu: userCode,
        perfilUsu: userProfile,
        usuario: userName,
        routeID: encodeURIComponent(routeId),
        codEmpresa: companyCode,
      },
      onStartLoad: () => setIsLoading(true),
      onEndLoad: () => setIsLoading(false),
      actionAfterResponse: (response) => {
        console.log(response);
      },
    });
  }, [apiCall, companyCode, routeId, userCode, userName, userProfile]);

  useEffect(() => {
    getMap();
  }, [getMap, signOut, token]);

  return (
    <>
      <Sidebar active="Lines" />
      <Loader isLoading={isLoading} />
      <Transitions>
        <PageHeader
          title={`Mapa da linha ${lineCode} - ${lineSign}`}
          link="/lines"
        />

        <MapContainer>
          <Iframe
            url={`${process.env.REACT_APP_PATHNAME}/Mapas/index.html?codUsu=${userCode}&usuario=${userName}&routeID=${encodeURIComponent(routeId)}&codEmpresa=${companyCode}&perfilUsu=${userProfile}&tk=${encodeURIComponent(token)}&showAllEmployees`}
            width="100%"
            height={`${window.innerHeight / 1.4015}px`}
            position="relative"
          />
        </MapContainer>

      </Transitions>
    </>
  );
}
